module.exports = __webpack_public_path__ + "img/Weapon_143.4408c8aa.png";